import { ModalProps } from '@/types/shared'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, FormItem } from 'vnetwork-ui'
import * as yup from 'yup'

export interface CancelOrDeleteProps extends ModalProps {
    invoiceID: number
    onSubmit: (category: string, message: string) => void
}

interface CancelOrDeleteFormData {
    category: string
    message: string
}

const CancelOrDelete: React.FC<CancelOrDeleteProps> = ({
    open,
    onClose,
    onSubmit,
}) => {
    const { t } = useTranslation()
    const { control, handleSubmit } = useForm<CancelOrDeleteFormData>({
        defaultValues: {
            category: '',
            message: '',
        },
        resolver: yupResolver(
            yup.object().shape({
                category: yup.string().required(t('required')),
                message: yup.string().required(t('required')),
            })
        ),
    })

    const onSubmitHandler = async (data: CancelOrDeleteFormData) => {
        if (!data?.message?.trim()) return

        onSubmit('cancel', data.message)
        onClose()
    }
    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={t('cancel-or-delete-invoice')}
        >
            <form
                onSubmit={handleSubmit(onSubmitHandler)}
                className="space-y-4"
            >
                <FormItem
                    control={control}
                    name="category"
                    type="select"
                    label={t('cancel-or-delete-category')}
                    options={[
                        {
                            label: t('because-error-on-billing'),
                            value: 'because-error-on-billing',
                        },
                        {
                            label: t('because-customer-cancel-service'),
                            value: 'because-customer-cancel-service',
                        },
                        {
                            label: t('because-not-contact-customer'),
                            value: 'because-not-contact-customer',
                        },
                        {
                            label: t('because-other-reasons'),
                            value: 'because-other-reasons',
                        },
                    ]}
                />
                <FormItem
                    control={control}
                    name="message"
                    type="textarea"
                    label={t('reason-cancel')}
                    placeholder={t('reason-cancel-placeholder')}
                />

                <div className="flex items-center justify-end gap-2">
                    <Button variant="outlined" onClick={onClose} type="button">
                        {t('cancel')}
                    </Button>
                    <Button type="submit">{t('confirm')}</Button>
                </div>
            </form>
        </Dialog>
    )
}

export default CancelOrDelete
